import React, { useRef, useState } from 'react';
import { iphoneAppDownload, androidAppDownload, iphoneRedeemCode } from '../link-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck, faMobileAlt, faRedo, faLaptop, faTabletAlt} from '@fortawesome/free-solid-svg-icons';
import LogoText from '../components/logoText';
import {Pricing} from "../components/Pricing";

import Carousel from "react-multi-carousel";

export const GolfVideo = () => {
    const introVid = useRef(null);
    const introButton = useRef(null);
    const special = useRef(null);
    let showSpecial = false;
    let sportKey = "golf";
    let promo = {
        name:'FedEx Cup Special',
        expiry: '24 Aug 2025',
        code: 'FEDEX25'
    }

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

/*
<div className="col-xl-7 col-lg-7 col-12 align-self-center" style={{marginBottom:'20px'}}>
                            <div className="atf-single-about-img text-center my-auto">
                                <h2 style={{ fontSize: '26px', lineHeight: "1.6", marginBottom: '20px' }}>Like recording your swing?</h2>
                                <h2 style={{ display:'inline-block', fontSize: '26px', marginTop: "10px", width: '50px', height: '50px', padding: '2px', borderRadius:'40px', backgroundColor: 'yellowgreen', color:"white"}}>5</h2>
                                <h2 style={{ fontSize: '26px', lineHeight: "1.6", color: "yellowgreen" }}>Reasons you'll love <LogoText light={false} /></h2>
                                <button onClick={() => { window.gtag('event', `video_play_${sportKey}_top`); introVid.current.play(); }} style={{padding: "10px 20px", fontSize: '14px', color: "white", background: "yellowgreen", border: '0px', borderRadius: '20px', marginTop:'20px'}}>Watch demo</button>


                            </div>
                        </div>

                        <div className="col-xl-5 col-lg-5 col-12 align-self-center text-center">
                            <video ref={introVid} controls width={"100%"} poster={"./watch_at_feet.png"} style={{marginTop: '20px'}}>
                                <source src="/assets/video/practiceLoopIntro.mp4" type="video/mp4" />
                            </video>

                        </div>

 */
    return (<div>
        

            <section className="atf-hero-area atf-shape" style={{padding: "50px 0px", backgroundImage: 'url(./assets/img/smokebg_dark.png)', backgroundColor: '#000000', backgroundSize: 'auto, auto'}}>
                <div className="container">
                    <div className="row justify-content-center clearfix">
                          <div className="d-none d-lg-block col-lg-7 col-0 text-center align-self-center atf-single-details pt-3">
                              <h2 style={{ marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa' }}>Fast feedback for fast improvement</h2>

                              <div className="mt-5">
                                    <div className=" text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                                        <h4 className="heading-size"style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                                        
                                            <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                                            <a href="#" onClick={() => iphoneRedeemCode("T20WC2026M")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                                
                                            <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                                            <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 15 Apr 2026</div>
                                            
                                    </div>
                              </div>
                          </div>
                          <div className="col-lg-5 col-12 text-center atf-single-details">
                            <div className="d-none d-lg-block" style={{height:'100px'}}></div>
                            <h2 className="heading-size d-block d-lg-none" style={{ marginTop: '50px', marginBottom: '20px', color:"white", fontFamily: 'Comfortaa', paddingTop: '10px' }}>Fast feedback<br />for fast improvement</h2>
                                                                            
                            <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                keyBoardControl={true}
                                customTransition="transform 300ms ease-in-out"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                            >
                                <div style={{position: 'relative'}}>
                                    <div className="d-block d-lg-none">
                                        <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Slow motion instant replays</h4>
                                    </div>
                                    <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                </div>
                                <div style={{position: 'relative'}}>
                                    <div className="d-block d-lg-none">
                                        <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Real-time analysis</h4>
                                    </div>
                                    <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                </div>
                                <div style={{position: 'relative'}}>
                                    <div className="d-block d-lg-none">
                                        <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Auto pause at key frames</h4>
                                    </div>
                                    <img src="./assets/img/cricket/bowling/test.png" alt="Elbow angle" />
                                </div>
                                <div style={{position: 'relative'}}>
                                    <div className="d-block d-lg-none">
                                        <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Cast to tablet or laptop</h4>
                                    </div>
                                    <img src="./assets/img/cricket/bowling/test.png" alt="Elbow angle" />
                                </div>
                            </Carousel>
                          </div>
                      </div>
                      <div className="d-block d-lg-none row justify-content-center clearfix mt-4">
                            <div className="text-center align-self-center p-2">
                                <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                                    <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                                    
                                    <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                                    <a href="#" onClick={() => iphoneRedeemCode("T20WC2026M")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                        
                                    <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                                    <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 13 Apr 2026</div>
                                </div>
                            </div>
                            </div>
                </div>
            </section>

        <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Real-time swing analysis</h2>
                              <p style={{ fontSize: "14px", lineHeight: "1.7", margin: "5px 0 0px 0"  }}>
                                Spine angle &#8226; 
                                Hip movement &#8226; 
                                Head movement &#8226;<br/>
                                Hand path &#8226; 
                                Trail elbow angle &#8226; 
                                Takeaway width<br/>
                                Takeaway path &#8226; 
                                Spine tilt &#8226; 
                                Point track</p>
                          </div>
                      </div>
                      <div className="col-lg-6 col-12 text-center pt-3">
                            <div className="container">
                                <div className="row justify-content-center clearfix text-center align-self-center">
                                    <div className="col-lg-3 col-12 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle"/>
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Spine angle</div></div>
                                    <div className="col-lg-3 col-6 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle"/>
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Spine tilt</div></div>
                                    <div className="col-lg-3 col-6 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle" />
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Hip slide</div></div>
                                    <div className="col-lg-3 col-4 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle" />
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Head track</div></div>
                                    <div className="col-lg-3 col-4 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle" />
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Hand path</div></div>
                                    <div className="col-lg-3 col-4 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle" />
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Trail arm angle</div></div>
                                    <div className="col-lg-3 col-4 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle" />
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Takeaway width</div></div>
                                    <div className="col-lg-3 col-4 p-1 d-block d-lg-none"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle" />
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Arm path</div></div>
                                    <div className="col-lg-3 col-4 p-1"><img src="./assets/img/cricket/bowling/test2.png" alt="Elbow angle" />
                                        <div style={{ fontSize: "13px", margin: '5px 0 5px 0'}}>Point track</div></div>
                                </div>
                            </div>      
                                                                
                      </div>
                      <div className="col-lg-6 col-12  d-none d-lg-block text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Real-time swing analysis</h2>
                              <p style={{ fontSize: '16px', lineHeight: "1.7", margin: "5px 0 0px 0"  }}>Spine angle &#8226; Hip movement &#8226; Head movement<br/>Hand path &#8226; Trail elbow angle &#8226; Takeaway width<br/>Takeaway path &#8226; Spine tilt &#8226; Point track</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

         <section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light.png'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-8 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Slow-motion instant replays</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"  }}>PracticeLoop detects your swing and shows a delayed replay right after your shot.<br/><strong>All hands free.</strong></p>
                              <p style={{ lineHeight: "1.7", margin: "5px 0 20px 0"  }}><FontAwesomeIcon icon={faCheck} style={{ color: 'yellowgreen', fontSize: '20px'}}></FontAwesomeIcon> Configure delay length and replay speed</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                        <img src="/assets/img/cricket/bowling/green_red_elbow_angle_compare.png" alt="Save individual swings"/>
                      </div>
                  </div>
              </div>
          </section> 

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="d-block d-lg-none col-lg-5 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-pause at takeaway, top, impact</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0",  }}>Configure the replay to automatically pause at a selected keyframe, to get better insights with each swing.</p>
                              <p style={{ lineHeight: "1.7", margin: "5px 0 0px 0"  }}><FontAwesomeIcon icon={faCheck} style={{ color: 'yellowgreen', fontSize: '20px'}}></FontAwesomeIcon> Set pause frame and pause length</p>
                              <p style={{ lineHeight: "1.7", margin: "5px 0 20px 0"  }}><FontAwesomeIcon icon={faCheck} style={{ color: 'yellowgreen', fontSize: '20px'}}></FontAwesomeIcon> Replay continues once pause is over</p>
                          </div>
                      </div>
                      <div className="col-lg-7 col-12 text-center">
                        <div className="container">
                            <div className="row justify-content-center clearfix text-center align-self-center">
                                <div className="col-lg-4 col-12 p-0">
                                    <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings"/>
                                    <p style={{marginTop: '-20px'}}>Takeaway</p>
                                </div>
                                <div className="col-lg-4 col-6 p-0">
                                    <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings"/>
                                    <p style={{marginTop: '-20px'}}>Top of swing</p>
                                </div>
                                <div className="col-lg-4 col-6 p-0">
                                    <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings"/>
                                    <p style={{marginTop: '-20px'}}>Impact</p>
                                </div>
                            </div>

                        </div>
                          
                      </div>
                      <div className="d-none d-lg-block col-lg-5 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-pause at takeaway, top, & impact</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 0px 0",  }}>Configure the replay to automatically pause at a selected keyframe, to get better insights with each swing.</p>
                          </div>
                      </div>
                  </div>

                  <div className="row justify-content-center clearfix mt-5">
                    <div className="col-lg-6 col-12 text-center align-self-center p-2">
                        <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                            <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                            
                            <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                            <a href="#" onClick={() => iphoneRedeemCode("T20WC2026M")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                
                            <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                            <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 13 Apr 2026</div>
                        </div>
                    </div>
                </div>

              </div>
          </section>
          <section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light.png'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-6 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Cast replay to tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 0px 0"  }}>Optionally connect a tablet or laptop to watch and analyze on a bigger screen, at your feet.</p>
                          </div>
                      </div>
                      <div className="col-lg-6 col-12 text-center">
                        <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                keyBoardControl={true}
                                customTransition="transform 300ms ease-in-out"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                            >
                                <img src="./assets/img/driving_range_pov.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
                                <img src="./watch_at_feet.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
                            </Carousel>

                          
                          
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-8 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-save every swing</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"  }}>All shots are automatically saved, individually, so you can re-watch them with a single tap.</p>
                              <p style={{ lineHeight: "1.7", margin: "5px 0 0px 0"  }}><FontAwesomeIcon icon={faCheck} style={{ color: 'yellowgreen', fontSize: '20px'}}></FontAwesomeIcon> Re-watch with single tap</p>
                              <p style={{ lineHeight: "1.7", margin: "5px 0 20px 0"  }}><FontAwesomeIcon icon={faCheck} style={{ color: 'yellowgreen', fontSize: '20px'}}></FontAwesomeIcon> Export all swings to video</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                          <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings" />
                      </div>
                      <div className="col-lg-8 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-save every swing</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"}}>All shots are saved, automatically and individually.</p>
                              <p style={{ lineHeight: "1.7", margin: "5px 0 0px 0"  }}><FontAwesomeIcon icon={faCheck} style={{ color: 'yellowgreen', fontSize: '20px'}}></FontAwesomeIcon> Re-watch with single tap</p>
                              <p style={{ lineHeight: "1.7", margin: "5px 0 20px 0"  }}><FontAwesomeIcon icon={faCheck} style={{ color: 'yellowgreen', fontSize: '20px'}}></FontAwesomeIcon> Export all swings to video</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

        <section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_dark.png'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 align-self-center">
                          <div>
                              <h2 className="heading-size text-center" style={{ color:"white"}}>Tip of the day</h2>
                                        <h4 className="text-center" style={{ fontSize: '24px', margin: '20px 0px 20px 0', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Turn your hips, don't slide</h4>
                                        <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 0px 0", color: '#EEEEEE'  }}>Moving your hips laterally (sliding) in your backswing causes inconsistency and reduces power.<br /><br />Use the "Hip slide" analyser to get instant feedback on whether you're turning, or sliding.</p>
                          
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                        <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={4000}
                                keyBoardControl={true}
                                customTransition="transform 300ms ease-in-out"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                            >
                                <div style={{marginBottom: '30px'}}>
                                    <img src="./assets/img/cricket/bowling/test.png" alt="Elbow angle" />
                                    <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>1. Set up</h4>
                                    <p className="px-5" style={{ fontSize: "14px", lineHeight: "1.7", margin: "5px 0 0px 0", color: '#EEEEEE'  }}>Set up your camera front on, and choose the "Hip slide" analyzer.</p>
                          
                                </div>

                                <div style={{marginBottom: '30px'}}>
                                    <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                        <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>2. Take a swing</h4>
                                        <p className="px-5" style={{ fontSize: "14px", lineHeight: "1.7", margin: "5px 0 0px 0", color: '#EEEEEE'  }}>Take a swing to measure how much your trail hip moved away from the target.</p>
                                </div>
                                <div style={{marginBottom: '30px'}}>
                                    <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                        <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>3. Learn, improve, repeat</h4>
                                        <p className="px-5" style={{ fontSize: "14px", lineHeight: "1.7", margin: "5px 0 0px 0", color: '#EEEEEE'  }}>Practice turning your hip behind you, instead of sliding, ideally getting the Hip Slide measurement to zero.</p>
                                </div>
                            </Carousel>

                          
                          
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 className='heading-size' style={{ color:"var(--thm-black"}}>Swing. Learn. Improve. Repeat.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0"  }}>To get better at any skill you need a feedback loop.</p>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 0px 0" }}>PracticeLoop provides tools to speed up your feedback loop, so you can improve faster.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-md-6 col-12 text-center">
						<div className="atf-img-inner" style={{backgroundImage: 'url(./assets/img/smokebg_white_light.png'}}>
							<div className="home-image-box">
								<div>
									<FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '60px' }}></FontAwesomeIcon>
									<h3 className="shake-1">Swing</h3>
									<p>Take a swing in front of your phone camera</p>
								</div>
								<div>
									<FontAwesomeIcon icon={faRedo} className="loopSpinner"></FontAwesomeIcon>
								</div>
								<div>
									<FontAwesomeIcon icon={faLaptop} style={{ color: 'var(--thm-color)', fontSize: '40px', marginBottom: '5px' }}></FontAwesomeIcon>
									<FontAwesomeIcon icon={faTabletAlt} style={{ color: 'var(--thm-color)', fontSize: '60px', margin: '0px 20px 0 20px' }}></FontAwesomeIcon>
									<FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '40px', margin: '0px 25px 5px 5px' }}></FontAwesomeIcon>
									<h3 className="shake-2">Learn and improve</h3>
									<p>Learn from real-time replays and analysis</p>
								</div>
							</div>
						</div>

					</div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
              <div className="container">
                  <div className="row justify-content-center" style={{backgroundColor: "yellowgreen"}}>
                      <div className="col-12 align-self-center text-center" style={{backgroundImage: 'url(assets/img/golf_collage.png)', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                          <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                              <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>500+ installs</h2><br />
                              <h2 style={{ display: "inline-block", fontSize: '18px', marginBottom: "10px", lineHeight: "1.5", padding: "3px"}}>"If you like recording your swing, you'll love PracticeLoop"</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <div className="row justify-content-center clearfix" style={{backgroundColor:'var(--thm-black)',  marginTop: '30px', padding: '25px 5px'}}>
              <div className="col-12 text-center" style={{padding:"20px"}}>
                  <h2 className="heading-size" style={{ margin: "0 0 10px 0", color: 'yellowgreen' }}>The best way to try <LogoText light={true} /></h2>
                  <div style={{color:'white', fontSize:'24px', fontWeight:"normal", lineHeight:'2rem', marginBottom: '20px'}}>is with our Masters Special</div>
                  <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                    <a href="#" onClick={() => iphoneRedeemCode("T20WC2026M")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                        
                    <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                    <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 15 Apr 2026</div>
              </div>
          </div>


        <div id="get-started" className="atf-section-padding atf-footer-offset">
              <div className="atf-brand-overlay">
                  <div className="container">
                      <div className="row justify-content-center clearfix wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
                          <div className="col-lg-8 col-md-8 col-11 text-center atf-mailchamp-headding atf-mailchamp-subscribe">
                              <h2 className="mb-1 text-center">Don't like specials?</h2>
                              <div>That's ok. Install normally here.</div>
                              <div>
                                  <a href="#none" onClick={() => iphoneAppDownload(`${sportKey}_video_bottom_cta`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                  </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
    </div>
    );
}
